import Strings from '../common/Strings';

export function getLoggedTimeFromMillis(millis, usePrefix) {
  let prefix;
  if (usePrefix) {
    if (millis < 0) {
      millis = millis * -1;
      prefix = '- ';
    } else {
      prefix = '+ ';
    }
  } else {
    prefix = '';
  }

  const minutes = Math.floor((millis / (1000 * 60)) % 60);
  const hours = Math.floor(millis / (1000 * 60 * 60));

  if (hours < 1) {
    if (minutes < 1) {
      return `${prefix + hours + Strings.COMMON.hoursShort}`;
    }
    return prefix + minutes + Strings.COMMON.minutesShort;
  } else if (hours === 1) {
    if (minutes === 0) {
      return `${prefix + hours + Strings.COMMON.hourShort}`;
    }
    return `${prefix + hours + Strings.COMMON.hourShort} ${minutes}${
      Strings.COMMON.minutesShort
    }`;
  }
  if (minutes === 0) {
    return `${prefix + hours + Strings.COMMON.hoursShort}`;
  }
  return `${prefix + hours + Strings.COMMON.hoursShort} ${minutes}${
    Strings.COMMON.minutesShort
  }`;
}

export function getLoggedTime(workLog) {
  return getLoggedTimeFromMillis(workLog.totalLoggedMillis);
}

export function getLoggedTimeFromHours(hours) {
  return getLoggedTimeFromMillis(hours * 1000 * 60 * 60);
}

export function getHoursFromMillis(millis, filterSecondsAndMilliseconds) {
  let millisToUse;
  if (filterSecondsAndMilliseconds) {
    millisToUse = dropSecondsAndMillisFromWorkLogMillis(millis);
  } else {
    millisToUse = millis;
  }
  return Number.parseFloat((millisToUse / (1000 * 60) / 60).toFixed(2));
}

export function dropSecondsAndMillisFromWorkLogMillis(millis) {
  return 1000 * 60 * parseInt(millis / (1000 * 60), 10);
}



// WEBPACK FOOTER //
// ./src/helpers/workLog.js